import { render } from "./PassengerDetails.vue?vue&type=template&id=2780fbc9&scoped=true&lang=pug"
import script from "./PassengerDetails.vue?vue&type=script&lang=ts"
export * from "./PassengerDetails.vue?vue&type=script&lang=ts"

import "./PassengerDetails.vue?vue&type=style&index=0&id=2780fbc9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2780fbc9"

export default script